import { css } from 'styled-components';

import {
  COLOR_BACKGROUND_GREY,
  COLOR_BLACK,
  COLOR_TEXT_GREY,
  COLOR_TURQUOISE,
  COLOR_WHITE,
} from './colors';

export default css`
  body {
    font-family: 'Mulish', sans-serif;
    color: ${COLOR_BLACK};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    background-color: ${COLOR_BACKGROUND_GREY};
  }

  p {
    line-height: 24px;
  }

  h1 {
    font-weight: 300;
    font-size: 25px;
    line-height: 35px;
  }

  h2 {
    font-size: 24px;
    line-height: 34px;
  }

  h3 {
    font-size: 23px;
    line-height: 35px;
  }

  h4 {
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 23px;
  }

  h5 {
    font-size: 16px;
    line-height: 26px;
  }

  .color-text-grey {
    color: ${COLOR_TEXT_GREY};
  }

  .color-text-white {
    color: ${COLOR_WHITE};
  }

  button {
    border: none;
    cursor: pointer;
    background: none;
    &:hover,
    &:focus,
    &:active {
      outline: none;
    }
  }

  a {
    color: ${COLOR_TURQUOISE};
    text-decoration: none;

    &:hover,
    &:active {
      text-decoration: underline;
      color: ${COLOR_TURQUOISE};
    }
  }

  input {
    display: block;
    width: 100%;
    border: none;
    outline: none;
  }

  .body-modal-open {
    overflow-y: hidden;
  }

  .body-modal-open #root {
    filter: blur(5px);
  }
`;
